import { render, staticRenderFns } from "./DepartmentControl.vue?vue&type=template&id=628d2b21&scoped=true&"
import script from "./DepartmentControl.vue?vue&type=script&lang=js&"
export * from "./DepartmentControl.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentControl.vue?vue&type=style&index=0&id=628d2b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628d2b21",
  null
  
)

export default component.exports